
$(function(){
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#cart_agree').is(':checked')) {
        $(this).submit();
      }
      else {
        const warning = `<p class="warning">Usted debe estar de acuerdo con los términos y condiciones.</p>`;
        if ($('p.warning').length === 0) {
          $('.agree_terms').after(warning);
        }
        //alert("Usted debe estar de acuerdo con los términos y condiciones.");
        return false;
      }
    });

    $('.gaea.totalbruto .cart__footer__value').on('DOMSubtreeModified', function(){
      let totalBrutoNew = $('.gaea.totalbruto .cart__footer__value').html(); // $163,360 CLP
      let limpiamos = totalBrutoNew.replace(' CLP', '').replace('$', '').replace('.', '');
      totalBrutoNew = parseInt(limpiamos);
      if(totalBrutoNew) {
        var descuentoTotal=0;

        $('.cart__items .cart__items__row .cart__items__grid').each(function(){
                let cantidad = $(this).children('.cart__items__quantity').children('.quantity__wrapper').children('.quantity__input').val();
                let precioNormal = $(this).children('.cart__items__price').children('.line__price').children('del').html();
                let precioRebajado = $(this).children('.cart__items__price').children('.line__price').children('mark').html();
                
                if(precioNormal){
                  let limpiamosNormal = precioNormal.replace(' CLP', '').replace('$', '').replace('.', '');  // $19.990
                  precioNormal = parseInt(limpiamosNormal);
                }
                if(precioRebajado){
                  let limpiamosRebajado = precioRebajado.replace(' CLP', '').replace('$', '').replace('.', '');  // $19.990
                  precioRebajado = parseInt(limpiamosRebajado);
                }
                
                if(precioNormal && precioRebajado){
                  let diferencia = (precioNormal-precioRebajado) * cantidad;
                  descuentoTotal+=parseInt(diferencia);
                  let descuentoTotalFormato = new Intl.NumberFormat('es-CL', {currency: 'CLP', style: 'currency'}).format(descuentoTotal) + ' CLP';

                  let subTotalNew = totalBrutoNew + descuentoTotal;
                  let subTotalFormato = new Intl.NumberFormat('es-CL', {currency: 'CLP', style: 'currency'}).format(subTotalNew) + ' CLP';

                  $('.gaea.descuentos .cart__footer__value').html(descuentoTotalFormato);
                  $('.gaea.subtotal .cart__footer__value').html(subTotalFormato);
                }                
         });
      }
    });
  

  // Ficha del producto añade guión al porcentaje de descuento
  $('.product__price__main span.porcentaje').prepend('-')


  // Colores colecciones
  $('.colores-wrap.colecciones .colores li').each(function(event){
    $(this).children("a").click(function(event){
      event.preventDefault();
      event.stopPropagation();
      
      let id = $( this ).parent().attr("data-id");
      let nombre = $( this ).parent().attr("data-name");
      let precioVenta = $( this ).parent().attr("data-price") /100;
      let precioVentaFormato = new Intl.NumberFormat('es-CL', {currency: 'CLP', style: 'currency'}).format(precioVenta);
      let precioOriginal = $( this ).parent().attr("data-compare_at_price") /100;
      let precioOriginalFormato = new Intl.NumberFormat('es-CL', {currency: 'CLP', style: 'currency'}).format(precioOriginal);
      let precioHtml='';
      let url = $( this ).attr("href");
      let tituloActual = $( this ).parent().parent().parent().parent().find("a").attr("href");
      
      // nuevo enlace en el titulo
      $( this ).parent().parent().parent().parent().children("a").attr("href",url);
      $( this ).parent().parent().parent().parent().children("a").find("p").text(nombre);

      // cambio de precio
      $( this ).parent().parent().parent().parent().children("a").find(".product__grid__price").empty();
      if(precioOriginal!=''){
        precioHtml=`
        <span class="price on-sale">${precioVentaFormato}</span>
        <span class="compare-at">${precioOriginalFormato}</span>
        `;
      }
      else {
        precioHtml=`
        <span class="price">${precioVentaFormato}</span>
        `;
      }
      $( this ).parent().parent().parent().parent().children("a").find(".product__grid__price").append(precioHtml);

      // cambio imagen
      $( this ).parent().parent().parent().parent().parent().children("product-grid-item-variant").each(function(){
        let attrId=$( this ).attr("data-grid-item");
        
        if(id==attrId) $( this ).removeAttr( "hidden" );
        else $( this ).attr( "hidden","hidden" );        
      });      
    });        
  });

  
});